/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MongoDataDocumentDto } from '../../models/mongo-data-document-dto';

export interface GetMongoDataDocument$Params {
  collection: string;
  id: string;
  'X-API-Version'?: string;
}

export function getMongoDataDocument(http: HttpClient, rootUrl: string, params: GetMongoDataDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<MongoDataDocumentDto>> {
  const rb = new RequestBuilder(rootUrl, getMongoDataDocument.PATH, 'get');
  if (params) {
    rb.path('collection', params.collection, {});
    rb.path('id', params.id, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MongoDataDocumentDto>;
    })
  );
}

getMongoDataDocument.PATH = '/api/mongo-data/collections/{collection}/documents/{id}';
